import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

export type StateProps = {
  disabled?: boolean
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.3')}px;
`

const styledButtonDisabledCss = ({ disabled }: StateProps) =>
  disabled &&
  css`
    color: ${themeGet('colors.text.disabled')};
    cursor: default;

    &:hover {
      color: ${themeGet('colors.text.disabled')};
    }
  `

export const StyledButton = styled.div<StateProps>`
  display: flex;
  justify-content: center;
  cursor: pointer;
  color: ${themeGet('colors.text.secondary')};

  &:hover {
    color: ${themeGet('colors.primary.dark')};
  }

  > svg {
    width: 16px;
    height: 16px;
  }

  ${styledButtonDisabledCss}
`
